import {
  calcDrawableChartMode,
  calcQuestionChartMode
} from '@aytm/app/stats/page/question-views/components/lib/chart-modes'

// Port of chart.coffee:46-55 and getDefaultChartMode lines 324-348.
//
// Unlike answer_variants chartModes, ecommerce takes into account:
//   - viewMode (see CHART_VIEW_OPTIONS — purchase, timing, subscribe and banner metrics)
//   - answerVariants.length > 12

// Both render as stacked bars per product, so the mode selector does not apply.
export const STACKED_VIEW_MODES = ['totalPickedUp', 'frequency']

export const getChartModeTypes = ({ viewMode, answerVariantsCount }) => {
  // totalPickedUp and frequency are special cases (stacked) — hide the modes selector.
  if (STACKED_VIEW_MODES.includes(viewMode)) return []

  if (answerVariantsCount > 12) {
    return viewMode === 'amount' ? ['brespondents', 'bpercents'] : ['brespondents']
  }

  return viewMode === 'amount'
    ? ['respondents', 'percents', 'brespondents', 'bpercents']
    : ['respondents', 'brespondents']
}

// the type's own rules; the exported resolver then fits the result to the modes the view offers
const calcPreferredChartMode = ({ chartMode, questionChartMode, globalChartMode, viewMode, answerVariantsCount }) => {
  const mode = calcQuestionChartMode(chartMode, questionChartMode, globalChartMode)

  if (STACKED_VIEW_MODES.includes(viewMode)) return 'bpercents'

  if (answerVariantsCount > 12) {
    if (viewMode === 'amount') {
      if (['pie', 'respondents'].includes(mode)) return 'brespondents'
      if (mode === 'percents') return 'bpercents'
      return mode
    }
    return 'brespondents'
  }

  // <=12
  if (viewMode === 'amount') {
    return mode === 'pie' ? 'respondents' : mode
  }
  if (['pie', 'percents'].includes(mode)) return 'respondents'
  if (mode === 'bpercents') return 'brespondents'
  return mode
}

export const getDefaultChartMode = args =>
  calcDrawableChartMode(calcPreferredChartMode(args), getChartModeTypes(args), {
    globalChartMode: args.globalChartMode
  })
